import { render, staticRenderFns } from "./FilterShippingProblem.vue?vue&type=template&id=4c042948&scoped=true&"
import script from "./FilterShippingProblem.vue?vue&type=script&lang=js&"
export * from "./FilterShippingProblem.vue?vue&type=script&lang=js&"
import style0 from "./FilterShippingProblem.vue?vue&type=style&index=0&id=4c042948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c042948",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VSheet,VTextField})
